import styled from 'styled-components';

import { colors } from 'theme/colors';

import DownloadIcon from 'ui/Icons/DownloadIcon';
import SmallDownload from 'ui/Icons/SmallDownload';

export const FileLayout = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 15px;
`;

export const FileFooter = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  max-width: 100%;
  align-content: flex-start;
`;

export const FileNameLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 8px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileName = styled.p`
  font-size: 14px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.palette.primary.dark};
  margin: 0;
  max-width: 80%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileSize = styled.p`
  font: normal normal normal 12px/14px Roboto;
  letter-spacing: 0px;
  color: ${colors.ui.chip.grayText};
  margin: 0;
  text-transform: uppercase;
`;

export const StyledSmallDownload = styled(SmallDownload)`
  color: ${colors.primary.main};
  font-size: 16px;

  margin-left: 16px;

  :hover {
    opacity: 0.8;
  }
`;

export const StyledDownloadIcon = styled(DownloadIcon)`
  cursor: pointer;
`;
